<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-tw w-left">
                <div class="c-td is-1">
                    <div class="typo-label">Detalista</div>
                    {{ data.locationName }}
                </div>
                <div class="c-td is-2">
                    <div class="typo-label">Kasa</div>
                    <h3 class="c-promos-title h6">{{ data.radId }}</h3>
                </div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-3">
                    <div class="typo-label">Promocja</div>
                    <h3 class="c-promos-title h6">{{ data.promoName }}</h3>
                </div>
                <div class="c-td is-4">
                    <div class="typo-label">Data</div>
                    {{
                        data.promoDate
                            ? $moment(data.promoDate).format('DD-MM-YYYY')
                            : ''
                    }}
                </div>
                <div class="c-td is-5">
                    <div class="typo-label">Liczba użyć</div>
                    {{ data.amount }}
                </div>
                <div class="c-td is-6">
                    <div class="typo-label">Prognozowany Zwrot Kosztów</div>
                    {{ (+data.refAmount).toFixed(2) }} zł
                </div>
                <!--<div class="c-td is-6">
                    <button
                        class="btn btn-auto c-promos-toggle"
                        data-toggle="collapse"
                        data-target="#reports-table-1"
                        aria-controls="reports-table-1"
                        aria-expanded="false"
                        @click="showShops = !showShops"
                    >
                        <a-icon icon="Dropdown" />
                        <span class="d-inline d-lg-none">Lokalizacje</span>
                    </button>
                </div> -->
            </div>
        </div>
        <div
            id="reports-table-1"
            class="c-tm collapse"
            :class="{ show: showShops }"
        >
            <h4 class="h5">Lokalizacje</h4>

            <table class="t">
                <tbody>
                    <tr v-for="(shop, idxx) in data.shops" :key="idxx">
                        <td class="t-d is-1">
                            {{
                                `${shop.name}, ${shop.street} ${shop.zipCode} ${shop.city}`
                            }}
                        </td>
                        <td class="t-d is-2">
                            <span class="status is-success">
                                <a-icon icon="Ok" />
                                <span>Aktywna</span>
                            </span>
                        </td>
                        <td class="t-d is-3">{{ shop.used }}</td>
                        <td class="t-d is-4">
                            {{ (+shop.refund).toFixed(2) }} zł
                        </td>
                        <td class="t-d is-5"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showShops: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>
